import isObject from 'lodash/isObject'

export const getOnlyNewsletterTitles = newsletters =>
  newsletters
    .map(newsletterName => {
      const [titleNewsletterName] = newsletterName.split('||')
      const [cleanedTitleNewsletterName] = titleNewsletterName.split(' (')
      return cleanedTitleNewsletterName
    })
    .join(' | ')

export const getNewsletterChanges = (newBrandNewsletters, initialBrandNewsletters = {}) =>
  Object.keys(newBrandNewsletters).reduce(
    (updatedNewsletters, newsletterName) => {
      if (initialBrandNewsletters[newsletterName] !== newBrandNewsletters[newsletterName]) {
        if (newBrandNewsletters[newsletterName]) {
          updatedNewsletters.subscriptionList.push(newsletterName)
        } else {
          updatedNewsletters.unsubscriptionList.push(newsletterName)
        }
      }
      return updatedNewsletters
    },
    {subscriptionList: [], unsubscriptionList: []}
  )

export const newslettersHasCategory = (newsletters, {delimiter = '||'} = {}) =>
  Object.keys(newsletters).every(newsletter => {
    // newsletter without interests
    if (!isObject(newsletters[newsletter])) {
      const [category, name, description] = newsletter.split(delimiter)
      return category && name && description
    }
    return false
  })

export const filterNewslettersByCategory = (newsletters, {delimiter = '||'} = {}) => {
  const filteredNewsletters = {}
  Object.keys(newsletters).forEach(newsletter => {
    // newsletter without interests
    if (!isObject(newsletters[newsletter])) {
      const [category, name, description] = newsletter.split(delimiter)
      if (category && name && description) {
        if (filteredNewsletters[category]) {
          filteredNewsletters[category][`${name}${delimiter}${description}`] = newsletters[newsletter]
        } else {
          filteredNewsletters[category] = {
            [`${name}${delimiter}${description}`]: newsletters[newsletter],
          }
        }
      } else {
        filteredNewsletters[newsletter] = newsletters[newsletter]
      }
    }
  })

  return filteredNewsletters
}

export const subscribedNewsletters = newsletters =>
  Object.keys(newsletters).reduce((accum, subscription) => {
    const subscribed = newsletters[subscription]
    // newsletter without interests
    if (!isObject(subscribed)) {
      if (subscribed) {
        accum += 1
      }
    }

    return accum
  }, 0)
